import { useCollection } from '../hooks/useCollection';
import GlobalSearch from './GlobalSearch';
import { formatCurrency } from '../utils/portfolioValue';

const StatCell = ({ label, value, valueClassName }) => (
  <div className="px-8 py-3.5 border-r border-white/[0.07] last:border-r-0">
    <div className={`font-heading font-bold text-[22px] leading-none ${valueClassName || 'text-white'}`}>
      {value}
    </div>
    <div className="text-[10px] uppercase tracking-[0.1em] text-white/40 mt-1.5">{label}</div>
  </div>
);

const HeaderStatsBand = ({ onSearchNavigate }) => {
  const { getCollectionStats, packStats, getGlobalHitRate, getPortfolioValue, portfolioLoading } = useCollection();
  const stats = getCollectionStats();
  const hitRate = getGlobalHitRate();
  const portfolioValue = getPortfolioValue();

  return (
    <div className="hidden md:flex items-center justify-between bg-navy-dark border-b-[3px] border-yellow px-10">
      <div className="flex">
        <StatCell label="Cards" value={stats.totalCards.toLocaleString()} valueClassName="text-yellow" />
        <StatCell label="Unique" value={stats.uniqueCards.toLocaleString()} />
        <StatCell label="Packs" value={packStats.totalPacks.toLocaleString()} />
        <StatCell
          label="Hit Rate"
          value={hitRate === null ? '—' : `${hitRate}%`}
          valueClassName="text-[#4ade80]"
        />
        <StatCell
          label="Portfolio Value"
          value={portfolioLoading ? '…' : formatCurrency(portfolioValue)}
          valueClassName="text-amber"
        />
      </div>
      <div className="w-72">
        <GlobalSearch compact onNavigate={onSearchNavigate} />
      </div>
    </div>
  );
};

export default HeaderStatsBand;
